import React from 'react';
import ActivityIndicator from 'creatella-react-components/lib/ActivityIndicator';
import './Loading.scss';

function Loading() {
    return (
        <div className='loading'>
            <ActivityIndicator className='loading--spinner' size={50} />
            <span className='loading--title'>Please Wait ...</span>
        </div>
    );
}

export default Loading;
